export const checkGiftFundReadOnly = ({ customDependencies }) => {
  const { initialGiftForDownPayment } = customDependencies;
  return (Number(initialGiftForDownPayment) || 0) > 0;
};
